import '../App.css';
import { Button } from 'react-bootstrap';
import { Form } from 'react-bootstrap';
import { Alert } from 'react-bootstrap';
import { useNavigate } from "react-router-dom";
import {Bodyheadregister} from './/bodyheadregister';
import Axios from 'axios';
import React, {useEffect, useState} from 'react';

function Bodyrecopass(props)
{
    const [seccionrecover, setSeccionRecover] = useState('seccionVisible')
    const [seccionmensaje, setSeccionMensaje] = useState('seccionNoVisible')
    const [seccionvalidacion, setSeccionValidacion] = useState('seccionNoVisible')
    const [mail, setMail] = useState('')
    const [alertHead, setAlertHead] = useState('');
    const [alertBody, setAlertBody] = useState('');
    const [alertClass, setAlertClass] = useState('');
    const [alertActivate, setAlertActivate] = useState(false)

    let statuscall = '' 

    const clickRecuperar = async (e) => {
        if (mail != '')
        {
            const recuperarPass = await Axios.get(process.env.REACT_APP_URLRECUPERAPASS, {
                params: {
                    mail: mail,  
                },
                headers: {
                    'Access-Control-Allow-Origin' : '*',
                    'Access-Control-Allow-Methods': 'GET, POST',
                    'Access-Control-Allow-Headers': 'Content-Type'
                }}).then(res => statuscall = res).catch(err => statuscall = err.response);
                
                if(statuscall.status == 200)
                {
                    setSeccionValidacion('seccionNoVisible')
                    setSeccionRecover('seccionNoVisible')
                    setSeccionMensaje('seccionVisible')
                }
                else
                {
                    setAlertHead('Recuperación de password')
                    setAlertBody(statuscall.data.Message + '. El usuario ingresado no existe en la base de datos del sistema. Si el error persiste, contáctese con el administrador o regístrese en el sistema.')
                    setAlertClass('danger')
                    setAlertActivate(true)
                    setTimeout(() => {
                        setAlertActivate(false)
                    }, 10000)
                }
        }
        else
        {
            setAlertHead('Recuperación de password')
            setAlertBody('Debe completar la informacion solicitada!. Ingrese el correo electrónico solicitado.')
            setAlertClass('warning')
            setAlertActivate(true)
            setTimeout(() => {
                setAlertActivate(false)
            }, 5000)
        }

    }

    const handlerMail = (e) =>{
        setMail(e.target.value)
    }

    return (
        <div className='sshbodyappContainerLogin'>
            <div className='sshbodyappContainerRegister'>
                <Bodyheadregister/>
            </div>
            <div className='sshbodyappContainerLoginCarrusel'>
            {alertActivate 
                ?<Alert variant={alertClass} onClose={() => setAlertActivate(false)} dismissible>
                <Alert.Heading>{alertHead}</Alert.Heading>
                <p>
                    {alertBody}
                </p>
              </Alert>
              : ''
            }
            </div>
            <div className='sshbodyappContainerLoginForm'>
                <div className='container'>
                    <div className={seccionrecover}>
                        <div className='row'>
                            <div className='col col-lg-5'></div>
                            <div className='col col-lg-2'>
                                <h1>Recuperar Contraseña</h1>
                            </div>
                            <div className='col col-lg-5'></div>
                        </div>
                        <div className='row'>
                            <div className='col col-lg-4'>
                            </div>
                            <div className='col col-lg-4'>
                                <Form.Control type="email" onChange={handlerMail} placeholder="Ingresa tu correo electronico"/>
                            </div>                                                                                    
                            <div className='col col-lg-4'>
                            </div>
                        </div>                             
                        <div className='row'>
                            <div className='col col-lg-4'></div>
                            <div className='col col-lg-4'>
                                <div className="d-grid gap-2">
                                    <Button onClick={clickRecuperar} variant="primary"  size="lg">
                                        Recuperar
                                    </Button>
                                </div>
                            </div>
                            <div className='col col-lg-4'></div>
                        </div>
                    </div>

                    <div className={seccionmensaje}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Se ha enviado un mail al correo
                                    ingresado con las intrucciones de 
                                    recuperacion de su contraseña</h5>
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>

                    <div className={seccionvalidacion}>
                        <div className='row'>
                            <div className='col col-lg-2'></div>
                            <div className='col col-lg-8'>
                                <h5>Debe ingresar un mail</h5>
                            </div>
                            <div className='col col-lg-2'></div>                            
                        </div>
                    </div>                                                    
                </div>
            </div>
        </div>            
    )    
}
export default Bodyrecopass